import React from 'react';
import './WindowSelectorModal.css';
import { useNavigate } from 'react-router-dom';

//const WindowSelectorModal = ({ isOpen, onClose }) => {
const WindowSelectorModal = ({ isOpen, onClose, quoteId, fkCustomerId, fkUserId, viewItem }) => {

  const navigate = useNavigate();
  //const { quoteId, quoteItemId, fkCustomerId, fkUserId, viewItem} = location.state || {};

  const handleSelect = (index) => {
    onClose();
    //navigate(`/windows/wint/w${index}`);
    navigate(`/windows/wint/w${index}`, {
      state: { quoteId, fkCustomerId, fkUserId, viewItem }, // 👈 Pass quoteId via route state
  });
  };

  if (!isOpen) return null;

  // Define the items per row:
  const rows = [
    [1, 2, 3],  // First row: 3 items
    [4, 5, 6, 7],  // Second row: 4 items
    [8, 9, 10, 11], // Third row: 4 items
    [12, 13, 14, 15], // Fourth row: 4 items
    [16, 17, 18, 19] // Fifth row: 4 items
  ];

  return (
    <div className="modal-backdrop" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <button className="close-button" onClick={onClose}>×</button>
        
        <div className="image-grid">
          {/* Render the first row with 3 items */}
          <div className="image-grid-row-1">
            {rows[0].map((itemIndex) => (
              <img
                key={itemIndex}
                src={`/images/win/w${itemIndex}.png`}
                alt={`Window ${itemIndex}`}
                onClick={() => handleSelect(itemIndex)}
              />
            ))}
          </div>

          {/* Render the remaining rows with 4 items each */}
          {rows.slice(1).map((row, rowIndex) => (
            <div className="image-grid-row-others" key={rowIndex}>
              {row.map((itemIndex) => (
                <img
                  key={itemIndex}
                  src={`/images/win/w${itemIndex}.png`}
                  alt={`Window ${itemIndex}`}
                  onClick={() => handleSelect(itemIndex)}
                />
              ))}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default WindowSelectorModal;
